/**
 * Attentive Modal Trigger Integration
 * Triggers the Attentive sign-up modal with device-specific creative IDs
 */

/**
 * Triggers the Attentive sign-up modal
 * @function triggerAttentiveModal
 * @returns {void}
 */
function triggerAttentiveModal() {
  if (typeof window.__attentive === 'undefined' || typeof window.__attentive.trigger !== 'function') {
    setTimeout(() => {
      if (typeof window.__attentive !== 'undefined' && typeof window.__attentive.trigger === 'function') {
        triggerAttentiveModal();
      } else {
        console.warn('Attentive SDK failed to load.');
      }
    }, 500);
    return;
  }

  // Determine device type (760px breakpoint per Attentive documentation)
  const isDesktop = window.innerWidth >= 760;

  // Get creative IDs from configuration (set via theme customizer block)
  const config = window.attentiveConfig || {};
  const DESKTOP_CREATIVE_ID = config.desktopCreativeId;
  const MOBILE_CREATIVE_ID = config.mobileCreativeId;

  const creativeId = isDesktop ? DESKTOP_CREATIVE_ID : (MOBILE_CREATIVE_ID || DESKTOP_CREATIVE_ID);

  window.__attentive.trigger(null, null, null, creativeId);
}

window.triggerAttentiveModal = triggerAttentiveModal;
